var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSierraLeone(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_7280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M496.077 345.042C506.368 317.309 512 287.313 512 255.999C512 224.685 506.368 194.689 496.077 166.956L256 144.695L15.923 166.956C5.632 194.689 0 224.685 0 255.999C0 287.313 5.632 317.309 15.923 345.042L256 367.303L496.077 345.042Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 511.999C366.07 511.999 459.906 442.527 496.076 345.042H15.922C52.094 442.527 145.928 511.999 256 511.999Z",
    fill: "#338AF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256 -0.000976562C145.928 -0.000976562 52.094 69.471 15.922 166.956H496.077C459.906 69.471 366.07 -0.000976562 256 -0.000976562Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_7280"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white",
    transform: "translate(0 -0.000976562)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSierraLeone);
export default __webpack_public_path__ + "static/media/sierraLeone.92b3160ccd76fa7f001cc279096e1d5a.svg";
export { ForwardRef as ReactComponent };